import React from 'react'
import { Card, Row, Col, Form } from 'react-bootstrap'

import { currencyConvert } from 'utility/convert.util'

const PaymentType = ({ invoice, onPaymentChange }) => {
  return (
    <div>
      <fieldset class="scheduler-border">
        <legend class="scheduler-border font-medium">ประเภทการชำระเงิน</legend>

        <Row>
          <Col sm="3">
            <Form.Group as={Row} className="mb-2">
              <Form.Label column sm={4} className="text-right">
                เงินสด
              </Form.Label>
              <Col sm={8}>
                <Form.Control
                  type="number"
                  value={invoice?.paymentType?.paidByCashAmount}
                  onChange={(e) =>
                    onPaymentChange('paidByCashAmount', Number(e.target.value))
                  }
                  className="text-right"
                />
              </Col>
            </Form.Group>
          </Col>
          <Col sm="3">
            <Form.Group as={Row} className="mb-2">
              <Form.Label column sm={4} className="text-right">
                โอน
              </Form.Label>
              <Col sm={8}>
                <Form.Control
                  type="number"
                  value={invoice?.paymentType?.paidByTransferAmount}
                  onChange={(e) =>
                    onPaymentChange(
                      'paidByTransferAmount',
                      Number(e.target.value),
                    )
                  }
                  className="text-right"
                />
              </Col>
            </Form.Group>
          </Col>
          <Col sm="3">
            <Form.Group as={Row} className="mb-2">
              <Form.Label column sm={4} className="text-right px-0">
                บัตรประชาชน
              </Form.Label>
              <Col sm={8}>
                <Form.Control
                  type="number"
                  value={invoice?.paymentType?.paidByCidAmount}
                  onChange={(e) =>
                    onPaymentChange('paidByCidAmount', Number(e.target.value))
                  }
                  className="text-right"
                />
              </Col>
            </Form.Group>
          </Col>
          <Col sm="3">
            <Form.Group as={Row} className="mb-2">
              <Form.Label column sm={5} className="text-right px-0">
                บัตรเครดิต/เดบิต
              </Form.Label>
              <Col sm={7}>
                <Form.Control
                  type="number"
                  value={invoice?.paymentType?.paidByCreditOrDebitAmount}
                  onChange={(e) =>
                    onPaymentChange(
                      'paidByCreditOrDebitAmount',
                      Number(e.target.value),
                    )
                  }
                  className="text-right"
                />
              </Col>
            </Form.Group>
          </Col>
          <Col sm="3">
            <Form.Group as={Row} className="mb-2">
              <Form.Label column sm={4} className="text-right px-0">
                QR
              </Form.Label>
              <Col sm={8}>
                <Form.Control
                  type="number"
                  value={invoice?.paymentType?.paidByQrAmount}
                  onChange={(e) =>
                    onPaymentChange('paidByQrAmount', Number(e.target.value))
                  }
                  className="text-right"
                />
              </Col>
            </Form.Group>
          </Col>
        </Row>
      </fieldset>
    </div>
  )
}

export default PaymentType
